<template>
  <div class="nxl-h-item d-none d-sm-flex">
    <div class="full-screen-switcher">
      <div class="nxl-head-link me-0" @click="changefullscreen">
        <i :class="isScreenFull ? 'feather-minimize minimize' : 'feather-maximize maximize'"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import screenfull from 'screenfull'

const isScreenFull = ref(false)

onMounted(() => {
  screenfull.on('change', () => {
    isScreenFull.value = screenfull.isFullscreen
  })
})

onBeforeUnmount(() => {
  screenfull.off('change')
})

const changefullscreen = () => {
  screenfull.toggle()
}
</script>
